import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { BiDataHook, BiEventType } from '@wix/da-bi/pkg/constants';
import GiveBadgeIconSmall from '@wix/da-ds/pkg/Icons/16x16/GiveBadge';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import { ResourceType } from '../../../types/resource';
import { CommentContext } from '../../CommentContext';
import s from './AwardBadgeButton.scss';
const AwardBadgeButton = ({ className , disabled , awardBadge  })=>{
    const { t  } = useTranslation();
    const { comment , isReduxReady  } = useContext(CommentContext);
    return(// Wrapper div because SimpleTooltip can render two elements at its root which will throw
    // off grid and flex layouts
    /*#__PURE__*/ React.createElement("div", {
        className: c(s['badge-button-wrapper'], className)
    }, /*#__PURE__*/ React.createElement(SimpleTooltip, {
        text: t('comment.action.badge.tooltip')
    }, /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['badge-button'],
        onClick: ()=>awardBadge(comment),
        disabled: disabled !== null && disabled !== void 0 ? disabled : !isReduxReady,
        "data-hook": BiDataHook.COMMENT_BADGE_BUTTON,
        biData: {
            evid: BiEventType.GIVE_BADGE_AWARD,
            sectionname: 'comments',
            typeid: ResourceType.COMMENT,
            itemid: comment.commentId
        },
        "aria-label": t('comment.a11y.action.badge')
    }, /*#__PURE__*/ React.createElement(GiveBadgeIconSmall, {
        className: s['badge'],
        customSizable: true,
        disableDefaultColors: true,
        size: IconSize.SMALLER
    })))));
};
AwardBadgeButton.displayName = 'AwardBadgeButton';
export default AwardBadgeButton;
